import styles from "./Sidebar.module.scss";

interface SidebarProps {
  views: { title: string; icon: React.ReactNode }[];
  selectedView: string;
  setSelectedView: any;
}

const Sidebar: React.FC<SidebarProps> = ({
  views,
  selectedView,
  setSelectedView,
}) => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.profileImg}>
        <div className={styles.profileImgText}>
          <span className={styles.avatarText}>{"LD"}</span>
        </div>
      </div>
      <div className={styles.navList}>
        {views.map((item) => {
          return (
            <div
              key={item.title}
              className={
                styles[`item${selectedView === item.title ? "Active" : ""}`]
              }
              onClick={() => {
                setSelectedView(item.title);
              }}
            >
              <span className={styles.icon}>{item.icon}</span>
              <span className={styles.text}>{item.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
